import moment from 'moment'
import { isNonEmptyText } from '@hw-core/utils'
import {
  extractInput, initList,
} from '../utils'
import { get } from './get'

// utililties
const isQuerySeeking = ({ seeking, seekingStart, q }) => {
  const input = q
  const inputHasValue = isNonEmptyText(input)
  const seekingHasValue = isNonEmptyText(seeking)
  const longTermOrPeriodicSeeking = ['long-term', 'periodic'].indexOf(seeking) > -1
  return !inputHasValue && seekingHasValue && seekingStart && longTermOrPeriodicSeeking
}

// query building
const buildQueryByFilters = (nonAdminQuery, queryParams) => {
  const minBirthday = new Date()
  minBirthday.setFullYear(minBirthday.getFullYear() - 50)
  
  const {
    status, step, plan, state, city, profession, group, oiwa, perPage, age, residency,
  } = queryParams
  let query = nonAdminQuery
  if (status) {
    if (step && (step === 'waiting_for_contract' || step === 'contract_pending')) {
      query = query.where('status', '==', 'accepted')
    } else {
      query = query.where('status', '==', status)
    }
  }
  if (plan) { // TODO marital status?
    const love = plan === 'suoritettu'
    query = query.where('love', '==', love)
  }
  if (state) {
    query = query.where('address.state', '==', state)
  }
  if (city.length > 0) { // TODO change city to cities
    query = query.where('address.city', 'in', city.map(c => c.toLowerCase()))
  }
  if (group) {
    query = query.where('step.group', '==', group)
  }
  if (step) {
    if (step === 'waiting_for_contract') {
      query = query.where('workContract.signed', '==', false).where('workContract.sent', '==', false)
    } else if (step === 'contract_pending') {
      query = query.where('workContract.signed', '==', false).where('workContract.sent', '==', true)
    } else {
      query = query.where('step.state', '==', step)
    }
  }
  if (profession) {
    query = query.where('profession', '==', profession)
  }

  // TODO: For Oiwa transition period only
  if (oiwa && oiwa.length > 0 && oiwa === 'oiwa_only') {
    query = query.where('oiwaApplicant', '==', true)
  }

  if (age) {
    query = query.where('birthday', '<', `${minBirthday.getFullYear()}-${minBirthday.getMonth() + 1}-${minBirthday.getDate()}`).where('birthday', '!=', '').orderBy('birthday', 'asc')
  }

  if (residency) {
    query = query.where('residency', '==', residency)
  }

  const { seeking, seekingEnd } = queryParams
  if (isNonEmptyText(seeking)) {
    query = query.where('application.seeking', 'array-contains', seeking)
    if (isQuerySeeking(queryParams) && seeking === 'periodic') {
      const indefiniteEndDate = new Date('3000')
      const seekingEndDate = seekingEnd ? new Date(moment(seekingEnd)) : indefiniteEndDate
      query = query.where('application.start', '<=', seekingEndDate)
    }
  }
  // addLimitToQuery
  query = query.limit(perPage)
  return query
}

// query augmentation
const addOrderToQuery = (originalQuery, orderBy) => originalQuery.orderBy(orderBy || 'created', 'desc')

const addLimitToQuery = (originalQuery, queryParams) => { // pagination
  const {
    page, perPage, startAfter, endBefore, actionChangePage, list,
  } = queryParams
  const input = extractInput(queryParams)
  const updatedList = initList(input, list)
  const listLength = updatedList.length
  const isListFull = listLength === perPage
  const isListEmpty = !updatedList || listLength < 1
  const isNotAtFirstPage = page > 1
  const firstListItem = updatedList[0]
  const lastListItem = updatedList[listLength - 1]

  let augmentedQuery = originalQuery
  if (isListFull) {
    if (actionChangePage === 'prev') {
      augmentedQuery = augmentedQuery.endBefore(firstListItem.created)
      augmentedQuery = augmentedQuery.limitToLast(perPage)
    }
    if (actionChangePage === 'next') {
      augmentedQuery = augmentedQuery.startAfter(lastListItem.created.toDate())
      augmentedQuery = augmentedQuery.limit(perPage)
    }
  } else if (isListEmpty && isNotAtFirstPage) {
    if (endBefore) { // page 2 to 1
      const endBeforeDate = new Date(+endBefore)
      augmentedQuery = augmentedQuery.endBefore(endBeforeDate)
      augmentedQuery = augmentedQuery.limitToLast(perPage)
    } else if (startAfter) { // page 2+
      const startAfterDate = new Date(+startAfter)
      augmentedQuery = augmentedQuery.startAfter(startAfterDate)
      augmentedQuery = augmentedQuery.limit(perPage)
    }
  } else {
    augmentedQuery = augmentedQuery.limit(perPage)
  }
  return augmentedQuery
}

const augmentQuery = (query, queryParams, orderBy) => {
  let augmentedQuery = query
  if (!isQuerySeeking(queryParams)) {
    augmentedQuery = addOrderToQuery(query, orderBy)
    augmentedQuery = addLimitToQuery(augmentedQuery, queryParams)
  }
  return augmentedQuery
}

const fetchApplications = queryParams => get(queryParams, buildQueryByFilters, augmentQuery)

export {
  // eslint-disable-next-line import/prefer-default-export
  fetchApplications,
}
